import { jsonApi } from '../client';
import type { LandlordUser, StoreLandlordUserProfileRequest, UpdatePasswordRequest } from './types';

const landlordUser = jsonApi('landlord/auth/user');

const user = (): Promise<LandlordUser> => {
  return landlordUser.get();
};

const updateProfile = (data: StoreLandlordUserProfileRequest): Promise<unknown> => {
  return landlordUser.put('profile', data);
};

const updatePassword = (data: UpdatePasswordRequest): Promise<unknown> => {
  return landlordUser.put('password', data);
};

export const landlordUserApi = {
  name: 'landlord-user',
  user,
  updateProfile,
  updatePassword,
};
